<template>
  <div id="CompagnyView" class="view" :style="minHeight">
    <page-intro 
      :sub-title="gpsst.enterpriseInfoSubTitle" 
      :view="'compagny'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-intro>
    <div v-if="enterpriseInfoChapo_g" class="editorial" v-html="enterpriseInfoChapo_g"></div>
    
    <compagny-form
      :tryValidateCompagny="tryValidateCompagny"
      v-on:end="$emit('changeview', { 'view': $store.state.appState.nextViewAfterCompagny })"
    ></compagny-form>

    <page-menu
      :view="'compagny'"
      v-on:changeview="$emit('changeview',$event)"
    ></page-menu>
  </div>
</template>

<script>
import PageIntro from "../components/PageIntro";
import PageMenu from "../components/PageMenu";
import CompagnyForm from "../components/compagny/CompagnyForm";

export default {
  name: "CompagnyView",
  props: {
    tryValidateCompagny: Boolean,
    minHeight: String
  },
  components: {
    PageIntro,
    PageMenu,
    CompagnyForm
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    },
    enterpriseInfoChapo_g: function() {
      return JsonDataModule.getValueWithGlossary(this.gpsst, 'enterpriseInfoChapo'); //eslint-disable-line no-undef
    }    
  },
  mounted: function() {
    initTooltips("#CompagnyView"); //eslint-disable-line no-undef
  },
  updated: function() {
    initTooltips("#CompagnyView"); //eslint-disable-line no-undef
  }
};
</script>

